import { render, staticRenderFns } from "./MaskingTemplate.vue?vue&type=template&id=5606a6b0&"
import script from "./MaskingTemplate.vue?vue&type=script&lang=ts&"
export * from "./MaskingTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports